<script>
  export let fullWidth = false;
</script>

<div class="locked-button noselect" class:fullWidth>Mint closed</div>

<style>
  .locked-button {
    background: #c51919;
    color: white;
    text-align: center;
    cursor: default;
    font-size: 12px;
    padding: 20px;
    line-height: 1;
    /* height: 36px; */
    box-sizing: border-box;
  }
  .fullWidth {
    width: 100%;
  }
</style>
